import { Component, ReactNode } from "react";

type Props = { children: ReactNode; fallbackTitle: string; fallbackText: string; retryLabel: string };
type State = { hasError: boolean };

class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: unknown) {
    console.error("[ErrorBoundary]", error);
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div className="min-h-screen flex items-center justify-center bg-background px-6">
        <div className="max-w-md text-center space-y-4">
          <h1 className="font-serif text-3xl text-foreground">{this.props.fallbackTitle}</h1>
          <p className="text-muted-foreground">{this.props.fallbackText}</p>
          <button
            type="button"
            className="rounded-full bg-primary px-6 py-3 text-primary-foreground shadow-soft transition-smooth hover:bg-primary/90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
            onClick={() => window.location.reload()}
          >
            {this.props.retryLabel}
          </button>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
